import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import cn from "classnames";
import s from "./Sidebar.module.scss";
import LinksGroup from "./LinksGroup/LinksGroup";
import { changeActiveSidebarItem } from "../../actions/navigation.js";
import { isAdminMitra } from "../../utils/adminMitra";

import TulufaliLogo from "../Icons/tulufali_logo.png";
import "eva-icons/style/eva-icons.css";

const Sidebar = (props) => {
  const { activeItem = "", ...restProps } = props;

  const [burgerBtnToggled, setBurgerBtnToggled] = useState(false);

  const [currentUser, setCurrentUser] = useState();
  const [peran, setPeran] = useState();
  const isMitra = isAdminMitra(currentUser);
  useEffect(() => {
    const u = JSON.parse(localStorage.getItem("user") || "null");
    if (u) {
      setCurrentUser(u);
      setPeran(u.peran || u.status || "");
    }
  }, []);

  useEffect(() => {
    if (props.sidebarOpened) {
      setBurgerBtnToggled(true);
    } else {
      setTimeout(() => {
        setBurgerBtnToggled(false);
      }, 0);
    }
  }, [props.sidebarOpened]);

  return (
    <nav className={cn(s.root, { [s.sidebarOpen]: burgerBtnToggled })}>
      <header className={s.logo}>
        <img src={TulufaliLogo} alt="Tulu Fali" />
        <div className={s.logoText}>
          <span className={s.title}>Tulu Fali <span className={s.version}>2.0</span></span>
          <span className={s.subtitle}>
            Terintegrasi <span className={s.subtitleBadge}>Esa Office</span>
          </span>
        </div>
      </header>
      <ul className={s.nav}>
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Dashboard"
          isHeader
          iconName={<i className="eva eva-home-outline" />}
          link="/template/dashboard"
          index="dashboard"
        />
        {!isMitra && (
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Pengaturan peta"
          isHeader
          iconName={<i className="eva eva-map-outline" />}
          link="/template/pengaturan-peta"
          index="pengaturanPeta"
        />
        )}
        <h5 className={[s.navTitle, s.groupTitle].join(" ")}>DATA</h5>

        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Profil Saya"
          isHeader
          iconName={<i className="eva eva-person-outline" />}
          link="/template/user/profile"
          index="profil"
          exact={false}
          childrenLinks={[
            {
              header: "Profile",
              link: "/template/user/profile",
            },
          ]}
        />

        {!isMitra && (
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Bantuan"
          isHeader
          iconName={<i className="eva eva-cube" />}
          link="/admin/bantuan"
          index="bantuan"
          exact={false}
          childrenLinks={[
            {
              header: "Jenis bantuan",
              link: "/admin/bantuan/jenis",
            },
            {
              header: "Data bansos",
              link: "/admin/bantuan",
            },
            {
              header: "Input Data Bansos",
              link: "/admin/bantuan/new",
            },
          ]}
        />
        )}

        {!isMitra && (
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Penerima"
          isHeader
          iconName={<i className="eva eva-people" />}
          link="/admin/penerima"
          index="penerima"
          exact={false}
          childrenLinks={[
            {
              header: "Data Penerima",
              link: "/admin/penerima",
            },
            {
              header: "Input Data Penerima",
              link: "/admin/penerima/new",
            },
            {
              header: "Upload Penerima",
              link: "/admin/penerima/upload",
            },
          ]}
        />
        )}

        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Bantuan Mitra"
          isHeader
          iconName={<i className="eva eva-briefcase-outline" />}
          link={isMitra ? "/admin/nirlaba/penerima" : "/admin/nirlaba/lembaga"}
          index="nirlaba"
          exact={false}
          childrenLinks={
            isMitra
              ? [
                  {
                    header: "Jenis program mitra",
                    link: "/admin/nirlaba/jenis",
                  },
                  {
                    header: "Program per tahun",
                    link: "/admin/nirlaba/program",
                  },
                  {
                    header: "Data penerima mitra",
                    link: "/admin/nirlaba/penerima",
                  },
                  {
                    header: "Input penerima mitra",
                    link: "/admin/nirlaba/penerima/new",
                  },
                ]
              : [
                  {
                    header: "Data lembaga",
                    link: "/admin/nirlaba/lembaga",
                  },
                  {
                    header: "Jenis program mitra",
                    link: "/admin/nirlaba/jenis",
                  },
                  {
                    header: "Program per tahun",
                    link: "/admin/nirlaba/program",
                  },
                  {
                    header: "Data penerima mitra",
                    link: "/admin/nirlaba/penerima",
                  },
                  {
                    header: "Input penerima mitra",
                    link: "/admin/nirlaba/penerima/new",
                  },
                ]
          }
        />

        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Desil"
          isHeader
          iconName={<i className="eva eva-grid-outline" />}
          link="/template/desil"
          index="desil"
          childrenLinks={[
            {
              header: "Desa",
              link: "/template/desil/desa",
            },
            {
              header: "Kecamatan",
              link: "/template/desil/kecamatan",
            },
            {
              header: "Cari Individu",
              link: "/template/desil/cari-individu",
            },
          ]}
        />

        {!isMitra && (
        <>
        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Progres Input"
          isHeader
          iconName={<i className="eva eva-repeat" />}
          link="/template/progressinput"
          index="progressinput"
          childrenLinks={[
            {
              header: "On Progress",
              link: "/template/progressinput/onprogress",
            },
            {
              header: "Selesai",
              link: "/template/progressinput/selesai",
            },
            {
              header: "Semua bantuan",
              link: "/template/progressinput/semua",
            },
          ]}
        />

        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="SK Bupati"
          isHeader
          iconName={<i className="eva eva-layers" />}
          link="/template/progressSK"
          index="progressSK"
          childrenLinks={[
            {
              header: "On Progress",
              link: "/template/progressSK/onprogress",
            },
            {
              header: "Selesai",
              link: "/template/progressSK/selesai",
            },
          ]}
        />

        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Makan Minum"
          isHeader
          iconName={<i className="eva eva-shopping-bag-outline" />}
          link="/admin/makan-minum"
          index="makan-minum"
          childrenLinks={[
            {
              header: "Dashboard Penyerapan",
              link: "/admin/makan-minum/dashboard",
            },
            {
              header: "Rekap Belanja Mamin",
              link: "/admin/makan-minum",
            },
            {
              header: "Belanja Mami PD",
              link: "/admin/makan-minum/belanja-pd",
            },
            {
              header: "Laporan Bulanan PD",
              link: "/admin/makan-minum/laporan-bulanan",
            },
          ]}
        />

        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Evaluasi"
          isHeader
          iconName={<i className="eva eva-checkmark" />}
          link="/template/evaluasi"
          index="evaluasi"
          childrenLinks={[
            {
              header: "Evaluasi Penerima",
              link: "/template/evaluasi/inputevaluasi",
            },
          ]}
        />
        {peran ? (
          peran == "super admin" ? (
            <LinksGroup
              onActiveSidebarItemChange={(activeItem) =>
                props.dispatch(changeActiveSidebarItem(activeItem))
              }
              activeItem={props.activeItem}
              header="Admin"
              isHeader
              iconName={<i className="fa fa-child" />}
              link="/admin/listadmin"
              index="listadmin"
              childrenLinks={[
                {
                  header: "Admin TF",
                  link: "/admin/listadmin",
                },
              ]}
            />
          ) : (
            <div />
          )
        ) : (
          <div />
        )}
        {peran ? (
          peran == "super admin" ? (
            <LinksGroup
              onActiveSidebarItemChange={(activeItem) =>
                props.dispatch(changeActiveSidebarItem(activeItem))
              }
              activeItem={props.activeItem}
              header="Kunci"
              isHeader
              iconName={<i className="eva eva-lock" />}
              link="/admin/kunci"
              index="kunci"
              childrenLinks={[
                {
                  header: "Kunci",
                  link: "/admin/kunci/kunciaturan",
                },
              ]}
            />
          ) : (
            <div />
          )
        ) : (
          <div />
        )}
        {/* <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header='Desa'
          isHeader
          iconName={<i className='eva eva-inbox-outline' />}
          link='/template/makan'
          index='makan'
          childrenLinks={[
            {
              header: 'Makan',
              link: '/template/makan/asupan',
            },
          ]}
        /> */}

        <LinksGroup
          onActiveSidebarItemChange={(activeItem) =>
            props.dispatch(changeActiveSidebarItem(activeItem))
          }
          activeItem={props.activeItem}
          header="Analitiks"
          isHeader
          iconName={<i className="eva eva-pie-chart-outline" />}
          link="/template/analitik"
          index="analitik"
          childrenLinks={[
            {
              header: "Miskin Ekstrim",
              link: "/template/analitik/miskinekstrim",
            },
            {
              header: "Fasilitas",
              link: "/template/analitik/fasilitas",
            },
            {
              header: "Penerima",
              link: "/template/analitik/penerima",
            },
          ]}
        />
        </>
        )}

        {peran && String(peran).toLowerCase() === "super admin" && (
          <LinksGroup
            onActiveSidebarItemChange={(activeItem) =>
              props.dispatch(changeActiveSidebarItem(activeItem))
            }
            activeItem={props.activeItem}
            header="Audit logs"
            isHeader
            iconName={<i className="eva eva-activity-outline" />}
            link="/admin/audit-logs"
            index="audit-logs"
          />
        )}
      </ul>
    </nav>
  );
};

Sidebar.propTypes = {
  sidebarOpened: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  activeItem: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

function mapStateToProps(store) {
  return {
    sidebarOpened: store.navigation.sidebarOpened,
    activeItem: store.navigation.activeItem,
  };
}

export default withRouter(connect(mapStateToProps)(Sidebar));
